import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Box, Typography } from "@mui/material";
import type { DateTime } from "luxon";
import { STATUS } from "../../theme/tokens";
import { ShiftType } from "../../utils/models";
import { formatDayName } from "../../utils/nursePanelUtils";

interface ApprovalDialogHeaderProps {
	title: string;
	shiftType: ShiftType;
	date: DateTime;
	shift_start?: DateTime;
	shift_end?: DateTime;
	isPartialShift?: boolean;
}

export const ApprovalDialogHeader: React.FC<ApprovalDialogHeaderProps> = ({ title, shiftType, date, shift_start, shift_end, isPartialShift = false }) => {
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				mb: 1,
				width: "100%",
				px: 2,
			}}
		>
			<Typography variant="h5" sx={{ fontWeight: 600, color: "primary.dark", fontSize: "28px" }}>
				{title}
			</Typography>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<AccessTimeIcon sx={{ fontSize: 20, color: isPartialShift ? STATUS.ERROR.main : "primary.dark", mr: 1 }} />
					<Typography sx={{ color: isPartialShift ? STATUS.ERROR.main : "primary.dark", fontWeight: isPartialShift ? 600 : 500 }}>
						{formatDayName(date)}, {date.toFormat("MMM DD")}
						<span style={{ marginLeft: 10 }}>{"  "}</span>
						{shift_start && shift_end && `${shift_start.toFormat("HH:mm")}-${shift_end.toFormat("HH:mm")}`}
						{isPartialShift && <span style={{ marginLeft: 8, fontSize: "0.9em" }}>(Partial)</span>}
					</Typography>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", ml: 0 }}>
					<Box
						component="img"
						src={shiftType === ShiftType.Night ? "/moon.svg" : "/sun.svg"}
						alt={shiftType === ShiftType.Night ? "Night shift" : "Day shift"}
						sx={{
							width: 20,
							height: 20,
							mr: 1,
						}}
					/>
					<Typography sx={{ color: "primary.dark", fontWeight: 500 }}>{shiftType === ShiftType.Night ? "Night Shift" : "Day Shift"}</Typography>
				</Box>
			</Box>
		</Box>
	);
};
